import moment from "moment";

export default function Footer() {
  return (
    <footer style={{justifyContent:'space-between',display:'flex'}}>
      <p className="footer-copyright">
        {moment().format('YYYY')} © Burhani Guards Indore All Rights Reserved.
      </p>
      <p className="footer-copyright">
        Design & Developed by Mustafa Vohra
      </p>
    </footer>
  );
}
